import Icon from '../components/Icon.vue'

Icon.register({
  times: {
    width: 352,
    height: 512,
    paths: [
      {
        d: 'M242.7 256l100.1 100.1c12.3 12.3 12.3 32.2 0 44.5l-22.2 22.2c-12.3 12.3-32.2 12.3-44.5 0l-100.1-100.1-100.1 100.1c-12.3 12.3-32.2 12.3-44.5 0l-22.2-22.2c-12.3-12.3-12.3-32.2 0-44.5l100.1-100.1-100.1-100.1c-12.3-12.3-12.3-32.2 0-44.5l22.2-22.2c12.3-12.3 32.2-12.3 44.5 0l100.1 100.1 100.1-100.1c12.3-12.3 32.2-12.3 44.5 0l22.2 22.2c12.3 12.3 12.3 32.2 0 44.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/times.js
// module id = 2011
// module chunks = 0